import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
    ButtonGroup,
    Button,
    InputControl,
    Container,
    ModalV2,
    ModalV2Title,
    ModalV2Content,
    ModalV2Footer,
    Row,
    Col,
} from '@si-armes/dsfr-react';
import { useForm } from 'react-hook-form';
import { getAPI, postAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import SelectQuestionsCompteUsager from '../../../../components/form/referentiel/select/SelectQuestionsCompteUsager';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_CHANGEMENT_RL_REINITIALISER_CREDENTIALS,
    API_CHANGEMENT_RL_VALIDATION_TOKEN,
    CONTEXT_CHANGEMENT_RL_REINITIALISER_CREDENTIALS,
    CONTEXT_CHANGEMENT_RL_VALIDATION_TOKEN,
} from '../../../../constants/apiUrls.constants';
import {
    isPswdIdentique,
    isPswdValid,
} from '../../creer/etape-2/components/MotDePasseCreationCompteEtape2';
import InputPassword from '../../../../components/Input/InputPassword';

const ReinitialisationCredentialsApresChangementRL = ({
    postApi,
    getApi,
    erreurValidationToken,
    dataValidationToken,
    dataReinitialiserCredentials,
    isLoadingReinitialiserCredentials,
}) => {
    const { register, handleSubmit, watch, formState, trigger, getValues } = useForm({
        mode: 'onChange',
        criteriaMode: 'all',
    });

    const { uuidHistorique } = useParams();

    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [messageSucces, setMessageSucces] = useState(null);
    const [messageErreur, setMessageErreur] = useState(null);
    const [displayModaleTokenInvalide, setDisplayModaleTokenInvalide] = useState(false);

    const dialog = useRef(null);

    const redirigerVersEcranConnexion = () => {
        window.location.href = process.env.REACT_APP_KEYCLOAK_LOGOUT_URI;
    };

    const ouvrirModaleTokenInvalide = () => {
        setDisplayModaleTokenInvalide(true);
    };

    useEffect(() => {
        if (displayModaleTokenInvalide && dialog.current) {
            dialog.current.showModal();
        }
    }, [displayModaleTokenInvalide]);

    const isStringNotEmpty = (stringToTest) => {
        return stringToTest !== '';
    };

    const isQuestionNotEmpty = () => {
        return (
            isStringNotEmpty(watch('question1')) &&
            isStringNotEmpty(watch('question2')) &&
            isStringNotEmpty(watch('question3'))
        );
    };

    const isReponseNotEmpty = () => {
        return (
            isStringNotEmpty(watch('reponse1')) &&
            isStringNotEmpty(watch('reponse2')) &&
            isStringNotEmpty(watch('reponse3'))
        );
    };

    const hasFormValid = () => {
        return (
            isReponseNotEmpty() &&
            isQuestionNotEmpty() &&
            isPswdValid(watch('motDePasse1')) &&
            isPswdIdentique(watch('motDePasse1'), watch('motDePasse2')) &&
            formState.isValid
        );
    };

    useEffect(() => {
        if (!getValues('question1') && !getValues('question2') && !getValues('question3')) return;
        trigger(['question1', 'question2', 'question3']);
    }, [watch('question1'), watch('question2'), watch('question3')]);

    useEffect(() => {
        getApi(
            usagerClientReducer,
            API_CHANGEMENT_RL_VALIDATION_TOKEN + uuidHistorique,
            CONTEXT_CHANGEMENT_RL_VALIDATION_TOKEN,
        );
    }, [uuidHistorique]);

    useEffect(() => {
        if (erreurValidationToken) {
            ouvrirModaleTokenInvalide();
        }
    }, [erreurValidationToken]);

    const verifierDoublonQuestion = (questionModifiee, autreQuestion1, autreQuestion2) => {
        const error =
            (questionModifiee === autreQuestion1 || questionModifiee === autreQuestion2) &&
            !!questionModifiee;
        if (error) {
            return 'La question est déjà sélectionnée, veuillez en choisir une autre.';
        }
        return null;
    };

    const getErreurMotDePasseInvalide = () => {
        if (watch('motDePasse1') && !isPswdValid(watch('motDePasse1'))) {
            return {
                message:
                    'Le mot de passe renseigné ne contient pas tous les éléments obligatoires. Veuillez en saisir un respectant le format indiqué.',
            };
        }
        return null;
    };

    const getErreurMotDePasseNonIdentique = () => {
        if (watch('motDePasse2') && !isPswdIdentique(watch('motDePasse1'), watch('motDePasse2'))) {
            return {
                message: "Veuillez renseigner le même mot de passe qu'au champ précédent.",
            };
        }
        return null;
    };

    const onSubmit = (dataForm) => {
        if (dataForm && hasFormValid() && uuidHistorique) {
            setIsButtonLoading(true);
            setMessageErreur(null);
            const dataFormat = {
                uuidHistorique,
                motDePasse: dataForm.motDePasse1,
                question1: dataForm.question1,
                question2: dataForm.question2,
                question3: dataForm.question3,
                reponse1: dataForm.reponse1,
                reponse2: dataForm.reponse2,
                reponse3: dataForm.reponse3,
            };

            postApi(
                usagerClientReducer,
                API_CHANGEMENT_RL_REINITIALISER_CREDENTIALS,
                dataFormat,
                CONTEXT_CHANGEMENT_RL_REINITIALISER_CREDENTIALS,
            )
                .then(() => {
                    setIsButtonLoading(false);
                })
                .catch((err) => {
                    setIsButtonLoading(false);
                    setMessageErreur(err.message || 'Une erreur est survenue');
                });
        }
    };

    useEffect(() => {
        if (dataReinitialiserCredentials && dataReinitialiserCredentials.login) {
            setMessageSucces(
                `Identifiants réinitialisés avec succès. Votre login est : ${dataReinitialiserCredentials.login}. Vous allez être redirigé vers la page de connexion.`,
            );
            setTimeout(() => {
                window.location.href = process.env.REACT_APP_KEYCLOAK_LOGOUT_URI;
            }, 5000);
        }
    }, [dataReinitialiserCredentials]);

    if (dataValidationToken === undefined && erreurValidationToken === undefined) {
        return (
            <Container>
                <div className="fr-grid-row fr-grid-row--center">
                    <div className="fr-col-12 fr-col-md-6">
                        <div className="fr-loader">
                            <span className="fr-loader__text">Chargement...</span>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }

    return (
        <Container>
            {displayModaleTokenInvalide ? (
                <ModalV2
                    id="tokenInvalide"
                    idModalTitle="tokenInvalide-title"
                    onClose={redirigerVersEcranConnexion}
                    size="sm"
                    ref={dialog}
                >
                    <ModalV2Content>
                        <ModalV2Title id="tokenInvalide-title">Token Invalide</ModalV2Title>
                        Le lien de réinitialisation est invalide ou a expiré.
                    </ModalV2Content>
                    <ModalV2Footer>
                        <div className="fr-grid-row">
                            <div className="fr-col-12 btn-group-align-right">
                                <Button
                                    name="Retour"
                                    variant="primary"
                                    onClick={redirigerVersEcranConnexion}
                                >
                                    Retour
                                </Button>
                            </div>
                        </div>
                    </ModalV2Footer>
                </ModalV2>
            ) : null}
            {messageSucces && (
                <div className="fr-alert fr-alert--success fr-alert--sm fr-mb-2w">
                    <p>{messageSucces}</p>
                </div>
            )}

            {messageErreur && (
                <div className="fr-alert fr-alert--error fr-alert--sm fr-mb-2w">
                    <p>{messageErreur}</p>
                </div>
            )}

            <h1
                aria-label="Réinitialisation des identifiants - Changement de responsable légal"
                className="text-center fr-mb-4w"
                data-testid="reinitialisation-credentials-title"
            >
                Réinitialisation des identifiants
            </h1>

            <p className="fr-text--lead fr-mb-4w">
                Veuillez renseigner les informations ci-dessous pour réinitialiser vos identifiants
                suite au changement de votre responsable légal.
            </p>

            <form onSubmit={handleSubmit(onSubmit)}>
                <Row className="fr-mb-4w">
                    <Col col={12}>
                        <h3 className="fr-h4">Définir votre mot de passe</h3>
                    </Col>
                </Row>
                <Row gutters style={{ 'flex-direction': 'row-reverse' }}>
                    <Col col={12} lg={4}>
                        <div className="fr-background-alt--grey fr-p-2w fr-radius">
                            <p className="fr-text--sm fr-mb-0">Le mot de passe doit contenir :</p>
                            <ul className="fr-text--sm fr-mb-0 fr-ml-4w">
                                <li>au moins 1 Majuscule</li>
                                <li>au moins 1 Minuscule</li>
                                <li>au moins 1 Chiffre</li>
                                <li>au moins 1 Caractère spécial (ex : + , - , ? , ! , % etc)</li>
                                <li>12 caractères minimum</li>
                            </ul>
                        </div>
                    </Col>
                    <Col col={12} lg={8}>
                        <InputPassword
                            name="motDePasse1"
                            label="Saisissez le mot de passe de votre compte :"
                            maxLength="300"
                            {...register('motDePasse1', {
                                required: 'Le mot de passe est obligatoire',
                            })}
                            error={getErreurMotDePasseInvalide()}
                        />
                        <InputPassword
                            name="motDePasse2"
                            label="Confirmez le mot de passe de votre compte :"
                            maxLength="300"
                            {...register('motDePasse2', {
                                required: 'La confirmation du mot de passe est obligatoire',
                            })}
                            error={getErreurMotDePasseNonIdentique()}
                        />
                    </Col>
                </Row>

                <Row className="fr-mt-4w fr-mb-4w">
                    <Col col={12}>
                        <h3 className="fr-h4">Questions de sécurité</h3>
                        <p className="fr-text--sm">
                            Sélectionnez 3 questions et saisissez les réponses associées. Ces
                            informations serviront en cas de problème d'accès à votre compte.
                        </p>
                    </Col>
                </Row>

                <Row gutters className="fr-mb-2w">
                    <Col col={12} lg={6}>
                        <SelectQuestionsCompteUsager
                            label="Question 1 :"
                            name="question1"
                            register={register('question1', {
                                required: 'La question 1 est obligatoire',
                                validate: (value) =>
                                    verifierDoublonQuestion(
                                        value,
                                        getValues('question2'),
                                        getValues('question3'),
                                    ),
                            })}
                            state={formState.errors?.question1 ? 'error' : null}
                            message={formState.errors?.question1?.message}
                        />
                    </Col>
                    <Col col={12} lg={6}>
                        <InputControl
                            id="reponse1"
                            name="reponse1"
                            label="Réponse 1 :"
                            maxLength="50"
                            uppercase
                            {...register('reponse1', {
                                required: 'La réponse 1 est obligatoire',
                            })}
                            state={formState.errors?.reponse1 ? 'error' : null}
                            message={formState.errors?.reponse1?.message}
                        />
                    </Col>
                </Row>
                <Row gutters className="fr-mb-2w">
                    <Col col={12} lg={6}>
                        <SelectQuestionsCompteUsager
                            label="Question 2 :"
                            name="question2"
                            register={register('question2', {
                                required: 'La question 2 est obligatoire',
                                validate: (value) =>
                                    verifierDoublonQuestion(
                                        value,
                                        getValues('question1'),
                                        getValues('question3'),
                                    ),
                            })}
                            state={formState.errors?.question2 ? 'error' : null}
                            message={formState.errors?.question2?.message}
                        />
                    </Col>
                    <Col col={12} lg={6}>
                        <InputControl
                            id="reponse2"
                            name="reponse2"
                            label="Réponse 2 :"
                            maxLength="50"
                            uppercase
                            {...register('reponse2', {
                                required: 'La réponse 2 est obligatoire',
                            })}
                            state={formState.errors?.reponse2 ? 'error' : null}
                            message={formState.errors?.reponse2?.message}
                        />
                    </Col>
                </Row>
                <Row gutters className="fr-mb-4w">
                    <Col col={12} lg={6}>
                        <SelectQuestionsCompteUsager
                            label="Question 3 :"
                            name="question3"
                            register={register('question3', {
                                required: 'La question 3 est obligatoire',
                                validate: (value) =>
                                    verifierDoublonQuestion(
                                        value,
                                        getValues('question2'),
                                        getValues('question1'),
                                    ),
                            })}
                            state={formState.errors?.question3 ? 'error' : null}
                            message={formState.errors?.question3?.message}
                        />
                    </Col>
                    <Col col={12} lg={6}>
                        <InputControl
                            id="reponse3"
                            name="reponse3"
                            label="Réponse 3 :"
                            maxLength="50"
                            uppercase
                            {...register('reponse3', {
                                required: 'La réponse 3 est obligatoire',
                            })}
                            state={formState.errors?.reponse3 ? 'error' : null}
                            message={formState.errors?.reponse3?.message}
                        />
                    </Col>
                </Row>

                <Row className="fr-mt-4w">
                    <Col>
                        <ButtonGroup inline align="right">
                            <Button
                                name="annuler"
                                variant="secondary"
                                type="button"
                                onClick={() => {
                                    window.location.href =
                                        process.env.REACT_APP_KEYCLOAK_LOGOUT_URI;
                                }}
                            >
                                Annuler
                            </Button>
                            <Button
                                name="valider"
                                variant="primary"
                                type="submit"
                                disabled={!hasFormValid() || isButtonLoading}
                                isLoading={isLoadingReinitialiserCredentials}
                            >
                                Valider
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </form>
        </Container>
    );
};

ReinitialisationCredentialsApresChangementRL.propTypes = {
    postApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    erreurValidationToken: PropTypes.shape({
        message: PropTypes.string,
    }),
    dataValidationToken: PropTypes.shape({
        uuidHistorique: PropTypes.string.isRequired,
    }),
    dataReinitialiserCredentials: PropTypes.shape({
        login: PropTypes.string.isRequired,
    }),
    isLoadingReinitialiserCredentials: PropTypes.bool,
};

export default connect(
    (state) => {
        const { data: dataValidationToken, erreur: erreurValidationToken } =
            state.compte.changementResponsableLegal.validationToken || {};
        const { data: dataReinitialiserCredentials, isLoading: isLoadingReinitialiserCredentials } =
            state.compte.changementResponsableLegal.reinitialiserCredentials || {};
        return {
            erreurValidationToken,
            dataValidationToken,
            dataReinitialiserCredentials,
            isLoadingReinitialiserCredentials,
        };
    },
    {
        postApi: postAPI,
        getApi: getAPI,
    },
)(ReinitialisationCredentialsApresChangementRL);
